// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__dM1oj","footer":"ModalUpdate_footer__19vvb"};